import { BaseFieldWidget, DefaultComparisonOperator, FormStringFieldSingleWidget, ModelFieldType, SPI, ViewType } from '@kunlun/dependencies';

@SPI.ClassFactory(
  BaseFieldWidget.Token({
    viewType: [ViewType.Form, ViewType.Search],
    ttype: ModelFieldType.String
  })
)
export class CoverFormStringField extends FormStringFieldSingleWidget {
  protected beforeCreated(): void {
    if (this.getUrlParameters().viewType === ViewType.Table && this.viewType === ViewType.Search) {
      (this.field as any).operator = (this.field as any).operator || DefaultComparisonOperator.EQUAL;
    }
  }
}
